import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useLanguage, translations } from '../i18n/LanguageContext';

export const LanguageSwitcher = () => {
  const { lang, switchLang, languages } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-[#C4A052] hover:text-[#D4B86A] hover:bg-[#C4A052]/10 flex items-center gap-1.5 px-2"
          data-testid="language-switcher"
        >
          <Globe className="h-4 w-4" />
          <span className="text-xs font-semibold uppercase">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-zinc-900 border-[#C4A052]/30 min-w-[160px]">
        {languages.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => switchLang(code)}
            className={`cursor-pointer flex items-center gap-2 ${
              lang === code
                ? 'bg-[#C4A052]/20 text-[#C4A052] font-semibold'
                : 'text-zinc-200 hover:bg-[#C4A052]/10'
            }`}
            data-testid={`lang-${code}`}
          >
            <span className="text-base">{translations[code]._flag}</span>
            <span className="text-sm">{translations[code]._label}</span>
            {lang === code && <span className="ml-auto text-xs">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
